module.exports = __webpack_public_path__ + "img/team-5.928b5e8.webp";